import type { ViewUIInputNumber } from '@salescore/core'
import { InputNumber, message } from 'antd'
import { t } from 'i18next'
import { useContext, useState } from 'react'

import { useViewUIRecordNodeContext } from './contexts'
import { ViewUIContext } from './ViewUIComponent'
import { viewUiValidation } from './viewUiValidation'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function ViewUIInputNumberC({ component }: { component: ViewUIInputNumber }) {
  const { isEditMode } = useContext(ViewUIContext)
  const { getValue, onChange } = useViewUIRecordNodeContext()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const originalValue = getValue(component.fieldName) as number
  const [value, setValue] = useState<number | null>(originalValue)
  // MEMO このフォームだけstateを対象にエラー判定している。
  //  他のフォームはcontextの値（ここで言うoriginalValue）を対象にしている。
  //  この差異を埋められれば、getValue()以降の処理をこのコンポーネント外でエラー判定することができ共通化を図れる。
  const errors = component.showError === true ? viewUiValidation(value, component) : []

  return (
    <InputNumber
      status={errors.length > 0 ? 'error' : undefined}
      value={value}
      onBlur={(e) => {
        onChange({ fieldName: component.fieldName, value })
      }}
      onChange={(value) => {
        setValue(value)
      }}
      onClick={() => {
        if (component.readonly === true) {
          void message.warning(t(`この項目は書き込みが禁止されています。`))
        }
      }}
      readOnly={isEditMode || component.readonly}
    />
  )
}
